<template>
  <app-layout>
    <v-stepper v-model="control" slot="header" style="border-bottom: 1px solid #DEDEDE">
      <v-stepper-header>
        <v-stepper-step :complete="control > 1" step="1">Informativo</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="control > 2" step="2">Relato</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="control > 3" step="3">Dados de Cadastro</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="control == 4" step="4">Finalizado</v-stepper-step>
      </v-stepper-header>
    </v-stepper>

    <v-stepper v-model="control" class="elevation-0">
      <v-stepper-items>
        <v-stepper-content step="1">
          <h5 class="text-justify">Ouvidoria da Polo iT</h5>
          <p
            class="text-justify"
          >A Ouvidoria da Polo iT Informação e Tecnologia tem como objetivo promover e incentivar a comunicação da empresa com clientes, fornecedores, colaboradores e o público externo em geral. Através desse canal, você poderá nos enviar sugestões de melhorias, elogios, informações, reclamações contra serviços e denúncias de atos lesivos que venham a ser praticados por membros da organização que violem o Código de Conduta da empresa e às legislações do país.</p>
          <h5 class="text-justify">O que é Ouvidoria?</h5>
          <p
            class="text-justify"
          >A ouvidoria é um espaço que funciona como ponte entre as partes interessadas e às organizações. É um serviço aberto ao público para receber reivindicações, denúncias, sugestões e também os elogios referentes aos serviços prestados pelas empresas, com foco principal na resolução de problemas.</p>
          <h5 class="text-justify">Como funciona?</h5>
          <p class="text-justify">
            Para registrar o seu manifesto você deverá clicar no link abaixo, preencher os campos necessários no formulário, escrever de forma detalhada o seu relato no item descrição e clicar em enviar.
            O seu relato será recebido pela área de ouvidoria da Polo iT, que irá direcioná-lo para tratamento interno com pessoal responsável. Daremos resposta ao manifesto através do e-mail fornecido.
          </p>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-form v-model="isRelatoValid" ref="relatoForm">
            <v-container grid-list-md fluid>
              <v-layout wrap>
                <v-flex xs12 md6>
                  <v-select
                    outlined
                    label="*Unidade"
                    v-model="value.area"
                    :items="unidades"
                    item-text="descricao"
                    item-value="valor"
                    :rules="[required]"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs12 md6>
                  <v-select
                    outlined
                    label="*Assunto"
                    v-model="value.assunto"
                    :items="assuntos"
                    item-text="descricao"
                    item-value="valor"
                    :rules="[required]"
                    required
                  >
                    <v-tooltip slot="append" v-model="assuntoTooltip">
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-help-circle-outline</v-icon>
                      </template>
                      <span>
                        <p class="text-justify">
                          <b>SUGESTÃO:</b> Sugestão de aprimoramento dos serviços prestados pela Polo iT;
                        </p>
                        <p class="text-justify">
                          <b>ELOGIO:</b> Demonstração de satisfação pelo serviço oferecido ou atendimento recebido;
                        </p>
                        <p class="text-justify">
                          <b>RECLAMAÇÃO:</b> Manifestação de insatisfação contra os serviços prestados;
                        </p>
                        <p class="text-justify">
                          <b>DENÚNCIA:</b> Comunicado de atividades ou atos ilícitos praticados por membros da organização ou partes envolvidas que lesionam o código de conduta da empresa e legislações;
                        </p>
                        <p class="text-justify">
                          <b>INFORMAÇÃO:</b>
                          Solicitação de endereço, referências, nome do responsável ou atendimento.
                        </p>
                      </span>
                    </v-tooltip>
                  </v-select>
                </v-flex>

                <v-flex xs12 md12>
                  <v-textarea
                    outlined
                    rows="15"
                    counter="2000"
                    label="*Descrição"
                    v-model="value.descricao"
                    :rules="[descricaoRule, required]"
                    required
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 md6>
                  <v-file-input
                    id="anexo"
                    show-size
                    dense
                    label="Anexo"
                    accept="image/*, .pdf"
                    :rules="[filerule]"
                  ></v-file-input>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-card v-show="loading == true" class="loader" width="100%" height="100%">
            <p class="display-1">Enviando...</p>
            <v-progress-circular indeterminate :color="'secondary'" :size="100" :width="10"></v-progress-circular>
          </v-card>
          <v-form
            v-show="loading == false"
            v-model="isDadosCadastraisValid"
            ref="dadosCadastraisForm"
          >
            <v-container grid-list-md fluid>
              <v-layout>
                <v-flex xs12>
                  <v-select
                    @change="onTipoIdentificacaoChange"
                    outlined
                    label="*Identificação"
                    v-model="value.tipoIdentificacao"
                    :items="tiposIdentificacoes"
                    item-text="descricao"
                    item-value="valor"
                    :rules="[required]"
                    required
                  >
                    <v-tooltip slot="append" v-model="tipoIdentificacaoTooltip" bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-help-circle-outline</v-icon>
                      </template>
                      <span>
                        <p class="text-justify">
                          <b>SIGILOSA:</b> Seus dados ficarão disponíveis somente para ouvidoria na tramitação do manifesto;
                        </p>
                        <p class="text-justify">
                          <b>ABERTA:</b> Seus dados ficarão abertos às partes interessas na tramitação do manifesto para agilidade no processo de atendimento e resolução;
                        </p>
                        <p class="text-justify">
                          <b>ANÔNIMA:</b> Seus dados não serão fornecidos, sendo, portanto, um manifesto de autor desconhecido;
                        </p>
                      </span>
                    </v-tooltip>
                  </v-select>
                </v-flex>
              </v-layout>

              <v-layout wrap v-if="!isAnonima">
                <v-flex xs12 md12>
                  <v-text-field
                    outlined
                    label="*Nome"
                    counter="50"
                    v-model="value.nome"
                    :rules="[required, nomeRule]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    outlined
                    v-mask="['###.###.###-##', '##.###.###/####-##']"
                    label="*CPF"
                    v-model="value.cpf"
                    :rules="[required, cpfRule]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12>
                  <p>Garantimos proteção e integridade total dos seus dados. Os dados serão utilizados unicamente para fins de cadastro e identificação do manifesto na ouvidoria.</p>
                </v-flex>

                <v-flex xs12 md12>
                  <v-text-field
                    outlined
                    v-mask="['+55 (##) #####-####']"
                    label="Telefone"
                    prepend-inner-icon="mdi-phone"
                    v-model="value.telefone"
                    :rules="[telefoneRule]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    outlined
                    prepend-inner-icon="mdi-email"
                    label="E-mail"
                    v-model="value.email"
                    :rules="[emailRule]"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 md12>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12>
                  <p>Caso a reclamação seja em nome de pessoa jurídica, se desejar forneça os dados da companhia</p>
                </v-flex>

                <v-flex xs12 md12>
                  <v-text-field outlined label="Razão Social" v-model="value.razaoSocial"></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    outlined
                    v-mask="['###.###.###-##', '##.###.###/####-##']"
                    label="CNPJ"
                    v-model="value.cnpj"
                    :rules="[cnpjRule]"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="4">
          <v-card width="100%" height="100%">
            <div v-if="result" class="card-center">
              <h4 class="display-1">RELATO ENVIADO COM SUCESSO!</h4>
              <p
                class="display-0"
              >A Polo IT agradece o contato, em breve daremos tratativa ao seu relato.</p>
            </div>
            <div v-else class="card-center">
              <h3 class="display-1">FALHA AO ENVIAR O RELATO</h3>
              <p
                class="display-0"
              >Houve uma falha inesperada ao tentar enviar o relato.Tente novamente mais tarde.</p>
            </div>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <!-- FOOTER -->

    <v-toolbar flat slot="footer" style="border-top: 1px solid #DEDEDE">
      <v-container grid-list-md fluid>
        <v-layout v-if="control == 1" style="padding-top: 5px">
          <v-flex xs12>
            <p class="text-center; body-1">
              Se deseja registrar sua manifestação na ouvidoria
              <v-btn color="secondary" x-small @click="control = 2">clique aqui</v-btn>
            </p>
          </v-flex>
        </v-layout>

        <v-layout v-if="control == 2">
          <v-spacer></v-spacer>
          <v-flex xs12 md2>
            <v-btn block color="secondary" @click="control = 1">Voltar</v-btn>
          </v-flex>
          <v-flex xs12 md2>
            <v-btn block color="primary" @click="onRelatoNextClick">Avançar</v-btn>
          </v-flex>
        </v-layout>

        <v-layout v-if="control == 3 && !loading">
          <v-spacer></v-spacer>
          <v-flex xs12 md2>
            <v-btn block color="secondary" @click=" control = 2">Voltar</v-btn>
          </v-flex>
          <v-flex xs12 md2>
            <v-btn block color="primary" @click="onConcluirClick">Concluir</v-btn>
          </v-flex>
        </v-layout>

        <v-layout v-if="control == 4">
          <v-spacer></v-spacer>
          <v-flex xs12 md2>
            <v-btn block color="secondary" @click="onResetOuvidoria">
              <span v-if="result">Novo Relato</span>
              <span v-else>Tentar novamente</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-toolbar>
  </app-layout>
</template>

<script>
import { validateBr } from "js-brasil";
import { mask } from "vue-the-mask";
export default {
  name: "Ouvidoria",
  components: {},
  directives: {
    mask
  },
  computed: {
    isAnonima: function() {
      return this.value.tipoIdentificacao == "AN";
    }
  },
  data: function() {
    return {
      tipoIdentificacaoTooltip: false,
      assuntoTooltip: false,
      isRelatoValid: true,
      isDadosCadastraisValid: true,
      loading: false,
      result: false,
      control: 1,
      value: {},
      anexo: [],
      unidades: [
        { descricao: "Administrativa", valor: "ADMI" },
        { descricao: "Comercial", valor: "COME" },
        { descricao: "Diretoria", valor: "POLO" },
        { descricao: "Desenvolvimento", valor: "DESE" },
        { descricao: "Financeira", valor: "FINA" },
        { descricao: "Técnica", valor: "TECN" },
        { descricao: "Treinamento", valor: "TReC" }
      ],
      assuntos: [
        { descricao: "Denúncia", valor: "D" },
        { descricao: "Elogio", valor: "E" },
        { descricao: "Informação", valor: "I" },
        { descricao: "Reclamação", valor: "R" },
        { descricao: "Sugestão", valor: "S" }
      ],
      tiposIdentificacoes: [
        { descricao: "Aberta", valor: "AB" },
        { descricao: "Anônima", valor: "AN" },
        { descricao: "Sigilosa", valor: "SI" },
      ],
      descricaoRule: v => !v || v.length <= 2000 || "Máximo de 2000 caracteres",
      required: v => !!v || "Campo obrigatório",
      requiredIf: (v, rule) => !rule || ((!!v && rule) || "Campo obrigatório"),

      nomeRule: v => !v || v.length <= 50 || "Máximo de 50 caracteres",
      emailRule: v => !v || /.+@.+\..+/.test(v) || "E-mail inválido",
      cpfRule: v => !v || validateBr.cpf(v) || "CPF inválido",
      cnpjRule: v => !v || validateBr.cnpj(v) || "CNPJ inválido",
      telefoneRule: v => !v || this.validarTelefone(v) || "Telefone inválido",
      filerule: v => {
        if (v === undefined || v === null || v.name === undefined) {
          return true;
        }
        //Size in bytes
        if (v.type.includes('image/') || v.type == "application/pdf") {
          if (v.size > 20000000) return "O anexo deve ser menor que 20 MB.";
        } else {
          return "Formato de arquivo inválido. São permitidos apenas arquivos de imagem e pdf";
        }
        return true;
      }
    };
  },
  methods: {
    validarTelefone(tel) {
      const telClean = tel.replace(/[^\d]+/g, "");
      tel = tel.replace(/_/g, "");
      //console.log('aki', telClean, telClean.length)
      if (!(telClean.length === 12 || telClean.length === 13)) {
        return false;
      }
      if (telClean[0] == 0 || telClean[2] == 0) {
        return false;
      }
      return true;
    },
    onTipoIdentificacaoChange() {
      if (this.value.tipoIdentificacao == "AN") {
        this.$refs.dadosCadastraisForm.resetValidation();
      }
    },
    onRelatoNextClick() {
      const arquivoAnexo = document.getElementById("anexo").files[0];
      if (this.$refs.relatoForm.validate()) {
        this.control = 3;
      }
    },
    async onConcluirClick() {
      // 1 - Validation
      if (!this.$refs.relatoForm.validate()) {
        this.control = 2;
        return;
      }
      if (
        this.value.tipoIdentificacao != "AN" &&
        !this.$refs.dadosCadastraisForm.validate()
      ) {
        return;
      }

      //2 - Change form to loading
      this.loading = true;

      //3 - Request
      await this.sendDataToApi()
        .then(() => {
          setTimeout(() => {
            this.result = true;
            this.control = 4;
          }, 3000);
        })
        .catch(() => {
          setTimeout(() => {
            this.result = false;
            this.control = 4;
          }, 3000);
        });
    },
    sendDataToApi() {
      let formData;
      formData = new FormData();
      //formData.append('data', JSON.stringify({area, assunto, descricao, tipoIdentificacao, tipoPessoa, nomeOuRazaoSocial, cpfOuCnpj, telefone, email}));
      formData.append("data", JSON.stringify(this.value));
      const arquivoAnexo = document.getElementById("anexo").files[0];
      if (arquivoAnexo !== undefined) {
        formData.append("anexo", arquivoAnexo, arquivoAnexo.name);
      }

      return this.axios({
        method: "post",
        data: formData,
        url: "https://8rryqi7xd8.execute-api.sa-east-1.amazonaws.com/prod/ouvidoria",
        headers: {
          "Content-Type": 'multipart/form-data; boundary="boundary"',
          "cache-control": "no-cache"
        }
      });
    },
    onResetOuvidoria() {
      this.loading = false;
      this.value = {};
      // document.getElementById("anexo").files[0] = null;

      this.$refs.relatoForm.reset();
      this.$refs.dadosCadastraisForm.reset();

      this.control = 1;
    }
  }
};
</script>

<style scoped>
.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 200px;
}

.content-overflow {
  overflow: hidden;
  height: 100% !important;
}

.card-center {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.dumb-label-fix {
  background-color: white;
}
</style>
